import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading: "'Noto Sans TC', sans-serif",
    text: "'Noto Sans TC', sans-serif",
    body: "'Noto Sans TC', sans-serif",
  },
});

export default theme;
